import { render, staticRenderFns } from "./dialogComponent.vue?vue&type=template&id=0e3827cf&scoped=true"
import script from "./dialogComponent.vue?vue&type=script&lang=js"
export * from "./dialogComponent.vue?vue&type=script&lang=js"
import style0 from "./dialogComponent.vue?vue&type=style&index=0&id=0e3827cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3827cf",
  null
  
)

export default component.exports